import { Star } from 'lucide-react';
import { useGoogleReviews } from '@/hooks/useGoogleReviews';

const GoogleReviewBadge = () => {
  const { data, loading } = useGoogleReviews();

  if (loading || !data) {
    return (
      <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full animate-pulse">
        <div className="w-20 h-4 bg-white/20 rounded" />
      </div>
    );
  }

  return (
    <a
      href={data.google_maps_url || "https://g.page/r/CW1vFSlnKC89EAE/review"}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-2 rounded-full hover:bg-white/20 transition-colors"
    >
      <img src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" alt="Google" className="w-4 h-4" loading="lazy" />
      <span className="font-bold text-white text-sm">{data.overall_rating}</span>
      <div className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            className={`w-3 h-3 ${star <= Math.round(data.overall_rating) ? 'text-amber-400 fill-amber-400' : 'text-white/30'}`}
          />
        ))}
      </div>
      <span className="text-white/70 text-xs">({data.total_ratings})</span>
    </a>
  );
};

export default GoogleReviewBadge;
